import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SharedModule } from '../../shared.module';
import { OwnerAdComponent } from './owner-ad.component';

@NgModule({
  declarations: [OwnerAdComponent],
  imports: [SharedModule, MatIcon, MatButtonModule],
  exports: [OwnerAdComponent],
})
export class OwnerAdModule {}
